export const upcomingScheduleList = [
    {
        id: 1,
        schedule_name: "React Dashboard Design",
        color: "success",
        date: {
            day: "20",
            month: "Dec",
            time: "11:30am - 12:30pm"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Socrates Itumay",
                user_img: "/images/avatar/4.png"
            },
            {
                id: 4,
                user_name: "Jakson Jak",
                user_img: "/images/avatar/6.png"
            },
        ]
    },
    {
        id: 2,
        schedule_name: "Admin Design Concept",
        color: "warning",
        date: {
            day: "30",
            month: "Dec",
            time: "10:00am - 12:00pm"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/5.png"
            },
            {
                id: 4,
                user_name: "Jakson Jak",
                user_img: "/images/avatar/6.png"
            },
        ]
    },
    {
        id: 3,
        schedule_name: "Standup Team Meeting",
        color: "primary",
        date: {
            day: "17",
            month: "Dec",
            time: "8:00am - 9:00am"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Socrates Itumay",
                user_img: "/images/avatar/4.png"
            },
            {
                id: 4,
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/5.png"
            },
        ]
    },
    {
        id: 4,
        schedule_name: "Zoom Team Meeting",
        color: "danger",
        date: {
            day: "25",
            month: "Dec",
            time: "03:30pm - 05:30pm"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Socrates Itumay",
                user_img: "/images/avatar/4.png"
            },
            {
                id: 3,
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/5.png"
            },
            {
                id: 4,
                user_name: "Jakson Jak",
                user_img: "/images/avatar/6.png"
            },
        ]
    },
]